import React from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';
import { Heart } from 'lucide-react';

const footerLinks = {
  'For Donors': [
    { label: 'Find a Cause', href: '/homepage' },
    { label: 'Gift Aid Guide', href: '/homepage' },
    { label: 'Donor Dashboard', href: '/donor-dashboard' },
    { label: 'Impact Reports', href: '/homepage#blog' },
  ],
  'For Beneficiaries': [
    { label: 'Apply for Support', href: '/beneficiary-application-form' },
    { label: 'Eligibility Criteria', href: '/homepage' },
    { label: 'Safeguarding Policy', href: '/homepage' },
    { label: 'GDPR & Privacy', href: '/homepage' },
  ],
  'For Charities': [
    { label: 'Partner Portal', href: '/charity-partner-portal' },
    { label: 'Register Your Charity', href: '/sign-up-login-screen' },
    { label: 'Campaign Guidelines', href: '/homepage' },
    { label: 'Charity Commission', href: '/homepage' },
  ],
  'Organisation': [
    { label: 'About Us', href: '/homepage' },
    { label: 'Our Team', href: '/homepage' },
    { label: 'Annual Reports', href: '/homepage' },
    { label: 'Press Enquiries', href: '/homepage' },
  ],
};

export default function HomepageFooter() {
  return (
    <footer className="bg-gray-900 text-gray-400">
      <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8 xl:px-10 2xl:px-16 py-16">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8 mb-12">
          <div className="col-span-2 md:col-span-3 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <AppLogo size={36} />
              <span className="font-display font-semibold text-white">World Giving</span>
            </div>
            <p className="text-sm leading-relaxed mb-4">
              Connecting UK donors directly with verified individuals, families and children in need.
            </p>
            <p className="text-xs">
              Regulated by the Charity Commission<br />
              for England and Wales
            </p>
          </div>
          {Object.entries(footerLinks)?.map(([section, links]) => (
            <div key={`footer-${section}`}>
              <h4 className="text-sm font-semibold text-white mb-4">{section}</h4>
              <ul className="space-y-2.5">
                {links?.map((link) => (
                  <li key={`footer-link-${link?.label}`}>
                    <Link href={link?.href} className="text-sm hover:text-white transition-colors">
                      {link?.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="border-t border-gray-800 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-center sm:text-left">
            © 2026 World Giving Organisation · worldgiving.org · All rights reserved
          </p>
          <div className="flex items-center gap-4 text-xs">
            <Link href="/homepage" className="hover:text-white transition-colors">Privacy Policy</Link>
            <Link href="/homepage" className="hover:text-white transition-colors">Cookie Policy</Link>
            <Link href="/homepage" className="hover:text-white transition-colors">Terms of Use</Link>
            <Link href="/homepage" className="hover:text-white transition-colors">Accessibility</Link>
          </div>
          <p className="text-xs flex items-center gap-1">
            Made with <Heart size={12} className="text-red-400" /> in the UK
          </p>
        </div>
      </div>
    </footer>
  );
}